import func from '@/script/func';
const state = {
    info: {
        __process: 1,
        __js: "/erp/index.js",
        __process_id: "",
    },
}
const mutations = {
    setProcessId(state, processId) {
        state.info.__process_id = processId;
    },
}
const actions = {
    async init({ state, commit, rootState }) {
        let p = func.sget("process_list");
        if (p && p.erp) {
            commit("setProcessId", p.erp)
        } else {
            let rs = await rootState.eapi.invoke("fork@create", state.info);
            if (rs.code == 1) {
                let p2 = func.sget("process_list");
                if (!p2) {
                    p2 = {};
                }
                p2.erp = rs.__process_id;
                func.ssave("process_list", p2)
                commit("setProcessId", rs.__process_id)
            } else {
                console.warn("------------------创建erp子进程失败");
            }
        }
    },
    async invoke({ state, rootState }, payload) {
        let { action, overTime, data } = payload;
        if (overTime === undefined) {
            overTime = 20000;
        }
        let rs = await rootState.eapi.invoke(action, Object.assign(state.info, data), overTime);
        return rs;
    },
}
const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
